import React from "react";
import "../Pages/styles/SearchPage.css";

const BookCardMobile = ({ eachHostel, hostelRedirect, price, showReviews }) => {
  if (!price) {
    price = eachHostel.minimumRoomPrice || eachHostel.price;
  }

  return (
    <div className="hostel-card">
      <div className="hostel-image-container">
        <img
          src={eachHostel.thumbnail}
          alt="Hostel"
          className="hostel-image"
        />
      </div>

      <div className="hostel-info">
        <div className="hostel-header">
        <h3 className="hostel-name">{eachHostel.hostel_name}</h3>

          {showReviews && (
            <span className="ratings">
              ⭐ {eachHostel.ratings || "-"} ({eachHostel.userRatingCount} reviews)
            </span>
          )}

        
        </div>
        
        <p className="hostel-description">{  eachHostel.description || "Comfortable stay with essential amenities."}</p>

        <div className="hostel-tags">
          {eachHostel.amenities.slice(0, 2).map((tag, index) => (
            <span key={index} className="tag">{tag}</span>
          ))}
        </div>

        <div className="hostel-footer">
          <div className="price-container">
            <span className="current-price">Rs. {price}</span>
          </div>
          <button className="book-button" onClick={() => hostelRedirect(eachHostel.id)}>Book Now</button>
        </div>
      </div>
    </div>
  );
};

export default BookCardMobile;
